import appConfig from "../Configs/app.config";
import {Navigate, Route, Routes} from "react-router-dom";
import {allRoutes} from "../Configs/routes.config";
import {PageContainer} from "../Components/template";
import AppRoute from "../Components/route/AppRoute";
import {memo} from "react";
import isEqual from "fast-deep-equal/react";

const {unAuthenticatedEntryPath} = appConfig

const Views = props => (
  <Routes>
    {
      allRoutes.map((route, index) => (
        <Route
          key={route.key + index}
          path={route.path}
          element={
            <PageContainer
              {...props} {...route.meta}
              pageContainerType="gutterless"
              footer={false}
            >
              <AppRoute
                routeKey={route.key}
                component={route.component}
                authority={route.authority}
                {...route.meta}
              />
            </PageContainer>
          }
        />
      ))
    }
    <Route path="*" element={<Navigate to={unAuthenticatedEntryPath} replace/>}/>
  </Routes>
)

export default memo(Views, isEqual)
